import React, { useEffect, useState } from "react";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import "./../LibSplide/LibSplide.scss";
import InitiativeCard from '../Initiative'
import _ from "lodash";
import api from "api";
import "./index.scss";
import update from "immutability-helper";

const InitiativeListGrouped = (props) => {
    
    const [involvedResearch, setInvolvedResearch]               = useState(false);
    const [involvedEvent, setInvolvedEvent]                     = useState(false);
    const [involvedTalent, setInvolvedTalent]                   = useState(false);
    const [involvedOther, setInvolvedOther]                     = useState(false);
    const [listInvolvedInitiative, setListInvolvedInitiative]   = useState('research');
    const [listArgs, setListArgs]                               = useState(props.list_args)

    const InitiativeTypes = [
        {id : 'research', label : 'Research'}
        ,{id : 'event', label : 'Event'}
        ,{id : 'talent', label : 'Talent'}
        ,{id : 'other', label : 'Other'}
    ];

    const GetInitiativeCount = (Type) => {
        switch(Type)
        {
            case 'research':return involvedResearch;
            case 'event':return involvedEvent;
            case 'talent':return involvedTalent;
            case 'other':return involvedOther;
        }
    }

    useEffect(() => {
        if(props.TotalResearch)
        {
            setInvolvedResearch(props.TotalResearch)
        }
        else
        {
            let GettingResearch = api('/Initiative', 'get', _.assignIn({}, {
                type : 'research', get_total : 1
            }, listArgs)).then(response => {
                setInvolvedResearch(response.initiative);
            });
        }

        if(props.TotalEvent)
        {
            setInvolvedEvent(props.TotalEvent)
        }
        else
        {
            let GettingEvent = api('/Initiative', 'get', _.assignIn({}, {
                type : 'event', get_total : 1
            }, listArgs)).then(response => {
                setInvolvedEvent(response.initiative);
            });
        }

        if(props.TotaTalent)
        {
            setInvolvedTalent(props.TotaTalent)
        }
        else
        {
            let GettingTalent = api('/Initiative', 'get', _.assignIn({}, {
                type : 'talent', get_total : 1
            }, listArgs)).then(response => {
                setInvolvedTalent(response.initiative);
            });
        }

        if(props.TotalOther)
        {
            setInvolvedOther(props.TotalOther);
        }
        else
        {
            let GettingOther = api('/Initiative', 'get', _.assignIn({}, {
                type : 'other', get_total : 1
            }, listArgs)).then(response => {
                setInvolvedOther(response.initiative);
            });
        }


    }, []);

    return (
        <div className="initiative-list-grouped">
            <div className=" involved-initiative-filters mb-md">
                <Splide options={{
                    autoWidth : true
                    ,pagination : false
                    ,arrows : false
                }}>
                    {
                        InitiativeTypes.map((InitiativeType) => {
                            let TotalInitiative = GetInitiativeCount(InitiativeType.id);
                            return (
                                
                                <SplideSlide key={InitiativeType.id}>
                                    <a href="#" className={`btn btn-small ${listInvolvedInitiative == InitiativeType.id && 'active'}`} onClick={e=>{
                                        e.preventDefault();
    
                                        setListInvolvedInitiative(InitiativeType.id);
                                    }}>
                                        {InitiativeType.label} {
                                            TotalInitiative > 0 &&<span className="value">{TotalInitiative}</span>
                                        } 
                                    </a>
                                </SplideSlide>
                            )
                        } )
                    }
                </Splide>
            </div>
            {
                _.filter(InitiativeTypes, (type) => {
                    return type.id == listInvolvedInitiative;
                }).map((InitiativeType) => (
                    <InitiativeSlider initiatives_args={_.assignIn({}, {
                        type : InitiativeType.id
                        , posts_per_page : 10
                        ,include_total_joined : true
                    }, listArgs)} key={InitiativeType.id} />
                ))
            }
        </div>
    )
}

const InitiativeList = (props) => {
    const [Initiatives] = useState(props.initiatives);

    return(
        <div className="initiative-list">
            {
                Initiatives.map((Initiative) => (
                    <div className="initiative-list-wrapper" key={Initiative.InitiativeID}>
                        <InitiativeCard  initiative={Initiative}/>
                    </div>
                ))
            }
        </div>
    )
}

const InitiativeSlider = (props) => {
    
    const [isEOF, setIsEOF]             = useState(false);
    const [isLoading, setIsLoading]     = useState(true);
    const [Initiatives, SetInitiatives] = useState(props.initiatives || false);
    const [listArgs, setListArgs]       = useState(_.assignIn({}, props.initiatives_args, {
        posts_per_page : 5
        ,paged : 1
    }) || {});

    useEffect(() => {
        setIsLoading(true);
        api( props.endpoint ? props.endpoint :  '/Initiative', 'get', listArgs, props.token || '').then(response => {
            setIsLoading(false);

            if(response.initiative.length < listArgs.posts_per_page)
            {
                setIsEOF(true);
            }

            if(Initiatives !== false)
            {
                SetInitiatives( Initiatives.concat(response.initiative));
            }
            else
            {
                SetInitiatives(response.initiative);
            }
            
        })
        .catch(() => {
            setIsLoading(false);
            setIsEOF(true);
        })

    }, [listArgs]);
    
    return(
        <div className="initiative-sliders">
            {
                <Splide options={{
                    autoWidth : true
                    ,pagination : false
                    ,arrows : false
                }}>
                    {
                        Initiatives !== false && Initiatives.map((Initiative) => (
                            <SplideSlide key={Initiative.InitiativeID}>
                                <InitiativeCard initiative={Initiative}/>
                            </SplideSlide>
                        ))
                    }
                    {
                        isLoading && 
                        <SplideSlide >
                            <div className="initiative-card">
                                <div className="card-skeleton initiative-card-wrapper shadow relative">
                                    <span className="skeleton"></span>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                    {
                        !isEOF && !isLoading &&
                        <SplideSlide>
                            <div className="initiative-card">
                                <div className="card-load-more initiative-card-wrapper shadow relative">
                                    <button className="load-more-card" onClick={e => {
                                        e.preventDefault();
                                        setListArgs(
                                            update(listArgs, {
                                                paged : {
                                                    $set : listArgs.paged ? listArgs.paged + 1 : 2
                                                }
                                            })
                                        );
                                    }}><span>Load More</span></button>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                    {
                        Initiatives !== false && Initiatives.length == 0 &&
                        <SplideSlide>
                            <div className="initiative-card">
                                <div className="card-not-found initiative-card-wrapper shadow relative">
                                    <span className="text-center bold block mt-4">
                                        No Initiative Found
                                    </span>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                </Splide>
            }
        </div>
    )
}

export {InitiativeSlider, InitiativeList, InitiativeListGrouped}